/**
 * Compose utility function - replacement for recompose's compose
 * Composes functions from right to left.
 * @param {...Function} funcs - The functions to compose
 * @returns {Function} A function that applies the composed functions
 */
export function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(
    (a, b) =>
      (...args) =>
        a(b(...args)),
  );
}

export default compose;
